<template>
    <button v-on:click="_cta" role="button" :title="`Go to ${href}`" class="c-button c-button--primary" v-html="content"></button>
</template>

<script>
export default {
    props: ['href', 'label', 'icon'],
    computed: {
        content: function() {
            return this.icon_html + this.label;
        },
        icon_html: function() {
            switch( this.icon ) {
                case 'document': return '<i class="fas fa-file"></i>';
                case 'help': return '<i class="fas fa-comment-alt"></i>';
                case 'map': return '<i class="fas fa-map"></i>';
                default: return '';
            }
        }
    },
    methods: {
        /**
         * perform the data layer push before navigating to the destination href
         */
        _cta: function() {

            this.dataLayerPush({
                "event": "highlight_cta_click",
                "highlight_name": this.$route.meta.title,
                "cta_text": this.label,
                "cta_url": this.href,
            });

            window.location.href = this.href;

        }
    }
}
</script>